'use client';

import { c as _c } from "react/compiler-runtime";
import { IcoSnsFace, IcoSnsFaceColor, IcoSnsInsta, IcoSnsInstaColor, IcoSnsNaver, IcoSnsNaverColor, IcoSnsX, IcoSnsXColor, IcoSnsYou, IcoSnsYouColor } from '@module/svg/icons';
import HoverIcon from '@pc/components/atoms/icon/HoverIcon';
import Link from 'next/link';
function SocialMediaLinks() {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <li className="mx-4 flex items-center"><Link prefetch={false} href="https://blog.naver.com/pandalive" target="_blank" rel="noreferrer"><HoverIcon defaultIcon={<IcoSnsNaver className="h-5 w-5" />} hoverIcon={<IcoSnsNaverColor className="h-5 w-5" />} /></Link></li>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <li className="mx-4 flex items-center"><Link prefetch={false} href="https://www.youtube.com/channel/UCAKpOL8SbgOrIMQElaXOtjA" target="_blank" rel="noreferrer"><HoverIcon defaultIcon={<IcoSnsYou className="h-5 w-5" />} hoverIcon={<IcoSnsYouColor className="h-5 w-5" />} /></Link></li>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <li className="mx-4 flex items-center"><Link prefetch={false} href="https://www.instagram.com/pandalive_tv/" target="_blank" rel="noreferrer"><HoverIcon defaultIcon={<IcoSnsInsta className="h-5 w-5" />} hoverIcon={<IcoSnsInstaColor className="h-5 w-5" />} /></Link></li>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <li className="mx-4 flex items-center"><Link prefetch={false} href="https://www.facebook.com/pandalivetv" target="_blank" rel="noreferrer"><HoverIcon defaultIcon={<IcoSnsFace className="h-3 w-3" />} hoverIcon={<IcoSnsFaceColor className="h-3 w-3" />} /></Link></li>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ul className="my-6 flex justify-center">{t0}{t1}{t2}{t3}<li className="mx-4 flex items-center"><Link prefetch={false} href="https://x.com/pandalivetv" target="_blank" rel="noreferrer"><HoverIcon defaultIcon={<IcoSnsX className="h-5 w-5" />} hoverIcon={<IcoSnsXColor className="h-5 w-5" />} /></Link></li></ul>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}
export default SocialMediaLinks;